/* Created by Anam Farrukh  */

(function () {
    'use strict';
    angular.module('tmx-common')
        //////////////////////////       DIRECTIVE         ////////////////////////////////////////////////////
        .directive("compareTo", function(){


            return {
                restrict: 'A',
                require: "ngModel",
                scope: {
                    otherModelValue: "=compareTo"
                },
                link: function(scope, element, attributes, ngModel) { //isolated directive scope
                    scope.confirmService=false;
                    ngModel.$validators.compareTo = function(modelValue) {
                        return modelValue == scope.otherModelValue;
                    };

                    scope.$watch("otherModelValue", function() {
                        ngModel.$validate();

                    });
                }
            };


        })


})();


